// extracted by mini-css-extract-plugin
module.exports = {"Button":"styles_Button__y6URU","disabled":"styles_disabled__xAXO0","inline":"styles_inline___clVO","active":"styles_active__f0XCK"};